<template>
  <div class="editor-header">
    <van-icon size="22px" name="arrow-left" @click="$emit('back')" />
    <div class="editor-header__actions">
      <span class="editor-header__gap"></span>
      <van-button color="#FF5700" size="small" @click="$emit('clear')">{{$t('append_field.clear')}}</van-button>
      <span class="editor-header__gap"></span>
      <van-button color="#006EFF" size="small" @click="$emit('restore')">{{$t('append_field.reduce')}}</van-button>
      <span class="editor-header__gap"></span>
      <van-button color="#006EFF" size="small" @click="$emit('fullscreen')">{{$t('append_field.fullscreen')}}</van-button>
      <span class="editor-header__gap"></span>
      <van-button color="#006EFF" size="small" @click="$emit('save')">{{$t('append_field.save')}}</van-button>
      <span class="editor-header__gap"></span>
      <van-button
        v-if="canSend"
        color="#006EFF"
        size="small"
        @click="$emit('send')"
      >
        {{$t('append_field.send')}}
      </van-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EditorHeader',
  props: {
    canSend: {
      type: Boolean,
      default: false,
    },
  },
}

</script>

<style scoped lang="scss">
.editor-header{
  padding: 15px 3px;
  display: flex;
  justify-content: space-between;
  .editor-header__actions {
    width: calc(100% - 40px);
    overflow-x: auto;
    white-space: nowrap;
    text-align: right;
  }
  .editor-header__gap {
    display: inline-block;
    width: 4px;
  }
  .van-icon{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

</style>
